import React, { Component } from 'react'
import StartButton from './StartButton.js'

class TrackInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      title: '',
      station: ''
    }
  }

  async getSongInfo() {
    const url = "https://audio.p99.media/api/nowplaying";
    const response = await fetch(url);
    const data = await response.json();
    var title;
    var station;
   
    var isLive = data[0]["live"]["is_live"];
    if (isLive) {
      title = "•Live"
    } else {
      title = data[0]["now_playing"]["song"]["text"];
    }

    station = data[0]["station"]["name"];
    console.log(data);


    this.setState({loading: false, title: title, station: station});
  }

  async componentDidMount() {
    await this.getSongInfo();
    this.interval = setInterval(() => { this.getSongInfo();}, 5000);
  }

  render() {
    let loading = "loading track info..."

    return (
      <div>
        <h3 className="TrackTitle">{this.state.loading ? loading : this.state.title}</h3>
        <StartButton />
        <h3 className="RadioName">{this.state.station}</h3>
      </div>
    )
  }
}

export default TrackInfo
